"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENSRootNodeStates = exports.ENSNodeZones = exports.ENSNodeStates = exports.ENS_ADDR_REVERSE_TLD = void 0;
exports.ENS_ADDR_REVERSE_TLD = 'addr.reverse';
var ENSNodeStates;
(function (ENSNodeStates) {
    ENSNodeStates["Reserved"] = "Reserved";
    ENSNodeStates["Claimed"] = "Claimed";
})(ENSNodeStates = exports.ENSNodeStates || (exports.ENSNodeStates = {}));
var ENSNodeZones;
(function (ENSNodeZones) {
    ENSNodeZones["ENS"] = "ENS";
    ENSNodeZones["CNS"] = "CNS";
    ENSNodeZones["ZNS"] = "ZNS";
})(ENSNodeZones = exports.ENSNodeZones || (exports.ENSNodeZones = {}));
var ENSRootNodeStates;
(function (ENSRootNodeStates) {
    ENSRootNodeStates["Submitted"] = "Submitted";
    ENSRootNodeStates["Verified"] = "Verified";
    ENSRootNodeStates["Released"] = "Released";
})(ENSRootNodeStates = exports.ENSRootNodeStates || (exports.ENSRootNodeStates = {}));
